import { useQuery } from "react-query";

import { fnFetchData } from "utils/requests";
import { endpointStatesOfCountry } from "services/endpoints";

import type { UseQueryResult, QueryObserverOptions, QueryKey } from "react-query";

/* ---------------
--- QUERY KEYS ---
------------------*/
export const qkCountryStates = (id: number): QueryKey => ["country-states", id];

/* ------------------
--- DATA FETCHING ---
---------------------*/
export function useGetStatesOfCountry(props?: useGetStatesOfCountryProps): UseQueryResult<any, any> {
  const { countryId = 1, options = {} }: useGetStatesOfCountryProps = props || {};
  const fn = () => fnFetchData({ config: { url: endpointStatesOfCountry({ id: countryId }) } });
  return useQuery(qkCountryStates(countryId), fn, options);
}

/* ------------------
--- INTERNAL TYPES ---
---------------------*/
interface useGetStatesOfCountryProps {
  countryId?: number;
  options?: QueryObserverOptions;
}
